import { DrawerTypeTypes } from 'src/contexts/customDashboardContext/types';

const drawerTitles: Record<Exclude<DrawerTypeTypes, null>, string> = {
  asset: 'Properties',
  textLabel: 'Text label - Properties',
  liveTagLabel: 'Live data label - Properties',
  rectangle: 'Rectangle - Properties',
  imageUpload: 'Image - Properties',
  tag: 'Properties',
};

export const generateTitleBasedOnDrawerType = (drawerType: DrawerTypeTypes) => {
  if (!drawerType) return 'Configuration';
  return drawerTitles[drawerType];
};
